import { render, staticRenderFns } from "./PageTopSection.vue?vue&type=template&id=47301b82&scoped=true&"
import script from "./PageTopSection.vue?vue&type=script&lang=js&"
export * from "./PageTopSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47301b82",
  null
  
)

export default component.exports